import ShowToast from "../../../../widget/common/ui/Toast";

export interface MapLatLongType {
  lat: number;
  lng: number;
  accuracy: number;
}

const ChatLocationProvider = new (class ChatLocationProvider {
  getGoogleCurrentLocation = async (): Promise<MapLatLongType | null> => {
    const coordinates: MapLatLongType = { lat: 0, lng: 0, accuracy: 0 };

    if (!navigator.geolocation) {
      ShowToast.error("Geolocation is not supported by your browser.");
      return coordinates;
    }

    try {
      const position: GeolocationPosition = await new Promise(
        (resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        }
      );
      console.log(position.coords.latitude, position.coords.longitude);
      return {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        accuracy: position.coords.accuracy,
      };
    } catch (err) {
      console.error("Geolocation error:", err);
    }

    return coordinates;
  };
})();

export default ChatLocationProvider;
